import axios from "axios";

export const Api = axios.create({
  baseURL: process.env.REACT_APP_API_KEY,
  headers: {
    "Content-Type": "application/json",
  },
});

Api.interceptors.request.use(async function (config) {
  // Add Authorization header
  config.headers["Authorization"] = `Bearer ${process.env.REACT_APP_API_TOKEN}`;

  // Add language header
  const lang = localStorage.getItem("i18nextLng") || "en";
  config.headers["Accept-Language"] = lang;

  return config;
});
